import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const ManagersCollectionPageNew = () =>
  import("@/views/manage/ManagersCollectionPageNew.vue").then((m) => m.default);
const ManagerProjects = () =>
  import("@/views/manage/managerDetails/ProjectsNew.vue").then(
    (m) => m.default
  );
const ManagerDocuments = () =>
  import("@/views/manage/managerDetails/DocumentsNew.vue").then(
    (m) => m.default
  );
const ManagerAbout = () =>
  import("@/views/manage/managerDetails/AboutNew.vue").then((m) => m.default);
const ManagerContractors = () =>
  import("@/views/manage/managerDetails/ContractorsNew.vue").then(
    (m) => m.default
  );
const ManagerJobPostings = () =>
  import("@/views/manage/managerDetails/JobPostingsNew.vue").then(
    (m) => m.default
  );
const ManagerRequests = () =>
  import("@/views/manage/managerDetails/RequestsNew.vue").then(
    (m) => m.default
  );
const Manager = () =>
  import("@/views/manage/Manager.vue").then((m) => m.default);

const getManagersRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/managers",
    component: RouteWrapper,
    meta: {
      title: "Managers",
      requiresAuth: true,
      breadcrumb: {
        title: BreadcrumbsTitles.COMPANY_RESOURCES,
        // icon: NavigationIcons.MANAGER,
        routeName: RouteNames.MANAGE_MANAGERS,
        classes: "contractor_detail_crubm",
        copyLink: false,
        isStyled: true,
      },
    },
    // children: [
    //   {
    //     path: "",
    //     name: RouteNames.MANAGE_MANAGERS,
    //     component: ManagersCollectionPageNew,
    //     meta: {
    //       title: "Managers",
    //       roles: [Roles.ADMIN, Roles.MANAGER],
    //       breadcrumb: {
    //         title: BreadcrumbsTitles.MANAGERS,
    //         // icon: NavigationIcons.MANAGER,
    //         routeName: RouteNames.MANAGE_MANAGERS,
    //         isStyled: true,
    //       },
    //     },
    //   },
    // ],
  },
]);

const getManagerPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "about",
    name: RouteNames.MANAGER_ABOUT,
    component: ManagerAbout,
    meta: {
      title: "About Manager",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        // title: BreadcrumbsTitles.MANAGER_DETAILS,
        // routeName: RouteNames.MANAGER_Edit,
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "projects",
    name: RouteNames.MANAGER_PROJECTS,
    component: ManagerProjects,
    meta: {
      title: "Manager Projects",
      roles: [Roles.ADMIN],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "contractors",
    name: RouteNames.MANAGER_CONTRACTORS,
    component: ManagerContractors,
    meta: {
      title: "Manager Contractors",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "requests",
    name: RouteNames.MANAGER_REQUESTS,
    component: ManagerRequests,
    meta: {
      title: "Manager Requests",
      roles: [Roles.ADMIN],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "job_postings",
    name: RouteNames.MANAGER_JOB_POSTINGS,
    component: ManagerJobPostings,
    meta: {
      title: "Manager Job Postings",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "documents",
    name: RouteNames.MANAGER_DOCUMENTS,
    component: ManagerDocuments,
    meta: {
      title: "Manager Documents",
      roles: [Roles.ADMIN],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getManagerPrivatePageRoutesWrapper: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    name: RouteNames.MANAGE_MANAGERS,
    component: RouteWrapper,
    meta: {
      title: "Managers",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Managers",
        // icon: NavigationIcons.MANAGER,
        routeName: RouteNames.MANAGE_MANAGERS,
        isStyled: true,
      },
    },
  },
]);
const getManagerPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    name: RouteNames.MANAGE_MANAGERS,
    component: ManagersCollectionPageNew,
    meta: {
      title: "Managers",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        // title: "All Managers",
        // // icon: NavigationIcons.MANAGER,
        // routeName: RouteNames.MANAGE_MANAGERS,
        isStyled: true,
      },
    },
  },
  {
    path: ":id",
    component: Manager,
    name: RouteNames.MANAGER_Edit,
    props: true,
    meta: {
      requiresAuth: true,
      title: "Manager",
      roles: [Roles.ADMIN],
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGER_DETAILS,
        routeName: RouteNames.MANAGE_MANAGERS,
        isStyled: true,
      },
    },
    children: [...getManagerPrivatePageTabsRoutes({})],
  },
]);
const getManagerPrivatePageTabRoutesChildren: GetRelativeRoutes =
  getChildRoutes([]);
export {
  getManagersRoutes,
  getManagerPrivatePageRoutes,
  getManagerPrivatePageTabsRoutes,
  getManagerPrivatePageRoutesWrapper,
  getManagerPrivatePageTabRoutesChildren,
};
